<template>
  <div class="express-main">
    <div class="search-bar">
      <!-- <div class="search-box">
        <van-icon name="search" class="search-icon"/>
        <van-icon class="search-icon iconfont" ></van-icon>
        <form action="javascript:void(0)"><input type="search" v-model="keyword" placeholder="请输入关键字" @keydown="searchHandle"/></form>
      </div> -->
      <van-search v-model="keyword" placeholder="请输入关键字" @keydown="searchHandle" style="width:100%;border-radius: 20px;"/>
      
    </div>
    <template v-if="emptyShow">
      <div v-for="(item, index) in data" :key="index">
        <div class="express-car" v-if="item.expressList.length>0">
          <HomeTitle :data="{title: item.typename,more: false}" @moreHandle="moreHandle"></HomeTitle>
          <div class="express-container">
            <div class="express-box" v-for="(car, idx) in item.expressList" :key="idx" @click="locationTo(car.busurl)">
              <p class="express-name">{{ car.busname }}</p>
              <p class="express-describe">{{ car.deptname }}</p>
              <span class="iconbox">
                  <img
                    class="icon-img"
                    onload="SVGInject(this)"
                    round fit="cover"
                    :src="complete(car.buspic)"
                  />
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="empty-container" v-else>
      <Error type="empty"/>
    </div>
  </div>
</template>

<script>
import {complete, baseURL} from "@/utils/url"
import * as svg from '@/utils/svg-inject.min'
import { queryList } from '@/api/express-car'
import {locationTo} from "@/utils/url"
export default {
  name: "ExpressCar",
  components: {
    HomeTitle: () => import('@/components/Home/HomeTitle')
  },
  data() {
    return {
      data: [],
      keyword: '',
      emptyShow: true //空空如也是否显示
    }
  },
  created() {
    this.init();
  },
  methods: {
    complete,
    locationTo,
    // 获取服务列表
    init() {
      queryList(this.keyword).then(res => {
        if (res && res.code == 200) {
          this.data = res.data;
          if (this.data) {
            let expressArr = [];
            this.data.forEach(item => {
              expressArr = expressArr.concat(item.expressList);
              /*if (item.expressList.length>0) {
                this.emptyShow = true
              }*/
            })
            if (expressArr.length>0) {
              this.emptyShow = true
            } else {
              this.emptyShow = false
            }
          } else {
            this.emptyShow = false
          }
        }
      })
    },
    // 专题服务点击事件
    serviceHandle(item) {
      this.$router.push('/project/details/'+item.id)
    },
    searchHandle(e) {
      if(e.code == 'Enter' || e.keyCode == '13') {
        this.init()
      }
    },
    moreHandle() {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.express-main{
  padding: 54px 15px 15px;
  .search-bar {
    width: 100%;
    height: 44px;
    padding: 8px 15px;
    box-sizing: border-box;
    display: -webkit-flex;/* Safari */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10001;
    background: #fff;
    color: $c333;
    .search-box {
      height: 28px;
      line-height: 28px;
      padding: 0 15px 0 35px;
      background: #F7F7F7;
      border: 1px solid #FFFFFF;
      border-radius: 14px;
      flex: 1;
      position: relative;
      @extend .font13;
      .search-icon{
        position: absolute;
        top:0;
        left: 15px;
      }
      form{
        width: 100%;
        background: transparent;
        height: 28px;
        line-height: 28px;
        padding: 0;
        input {
          float: left;
          width: 100%;
          height: 28px;
          line-height: 28px;
          background: transparent;
          @extend .font13;
          &::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }
    }
  }
  .express-container{
    padding: 0 0 15px;
    display: flex;
    flex-wrap: wrap;
    .express-box {
      position: relative;
      width: 86px;
      height: 60px;
      padding: 15px 65px 15px 15px;
      flex-shrink: 0;
      background: #FAFAFA;
      border-radius: 5px;
      margin-right: 13px;
      margin-bottom: 13px;
      &:nth-child(2n){
        margin-right: 0;
      }
      p{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.express-name{
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
        }
        &.express-describe{
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          color: #999;
        }
      }
      .iconbox {
        display: block;
        width: 40px;
        height: 40px;
        position: absolute;
        right: 15px;
        bottom: 15px;
        
        img, svg {
          display: block;
          width: 40px;
          height: 40px;
          fill: #003d88;
        }
      }
    }
  }
}
</style>
